<template>
    <div style="height: 100%;background-color: #fff; ">
        <div v-if="!selected_client">
            <h5 style="text-align: center;margin: 10px">
                {{ $t('AppFieldsManager.Selecione um cliente para carregar os locais') }}
            </h5>
        </div>

        <div v-else>
            <div v-if="loading">
                <ProgressSpinner
                    style="display: flex;align-items: center;justify-content: center;height: 40px"/>

                <h5 style="text-align: center;margin-top: 10px">
                    {{ $t('AppFieldsManager.Carregando') }}
                </h5>
            </div>
            <div v-else-if="client_with_too_many_fields" style="text-align: center;font-size: 14px;margin-top:20px">
                {{ $t('AppFieldsManager.Não foi possível recuperar os talhões') }}.
            </div>

            <div v-else style="height: 100%" class="list">
                <div class="mt-4"
                     style="font-size:20px;font-weight: 800;color: black;display: flex; justify-content: center">
                    {{ $t('AppFieldsManager.Lista de Locais') }}
                </div>
                <div style="width: 100%;display: flex;justify-content:center;align-items:center;" class="mt-4">
                    <div style="width: 70%;">
                        <span class="p-input-icon-left" style="width: 100%;">
                            <i class="pi pi-search"/>
                            <InputText type="text" v-model="search"
                                       :placeholder="$t('AppFieldsManager.Procurar Local')"/>
                        </span>
                    </div>
                </div>
                <perfect-scrollbar id="container" class="mt-4" :class="{'height-list': is_col_12}">
                    <div v-for="field in fieldsListToShow" :id="field.name" v-tooltip="showAreaText(field.area)"
                         :class="{selectedField: isSelectedField(field.id), field: true}"
                         @click="changeSelectedField(field)">
                        {{ field.name }}
                    </div>
                </perfect-scrollbar>

                <div class="add-button">
                    <app-button type="primary" @handleClick='addNewField'>
                        + {{ $t('AppFieldsManager.Adicionar Local') }}
                    </app-button>
                    <app-button v-if="detecting_fields" type="secondary" class="ml-2" @handleClick='stopFieldDetection'>
                        {{ $t('AppFieldsManager.Interromper detecção de talhões') }}
                    </app-button>
                </div>
            </div>
        </div>
        <app-shapefile-preview-dialog :visible.sync="previewDialog" :preview-data="previewData"
                                      :saving="importing" @import="onImport"/>

        <Dialog :visible.sync="addFieldDialog" :style="{width: '450px'}"
                :header="$t('AppFieldsManager.Adicionar Local')" :modal="true"
                :closable="!disableFileUpload" :closeOnEscape="!disableFileUpload">
            <div class="row">
                <div class="col">
                    <app-button type="primary" style="width: 90%;height: 47px;font-size: 18px"
                                :disabled="disableFileUpload" @handleClick='createField'>
                        <span class="pi pi-pencil pr-2"></span>
                        {{ $t('AppFieldsManager.Desenhar') }}
                    </app-button>
                </div>
<!--                <div class="col">-->
<!--                    <app-button type="primary" style="width: 100%;height: 47px;font-size: 18px"-->
<!--                                @handleClick='detectFields'>-->
<!--                        <span class="pi pi-search pr-2"></span>-->
<!--                        {{ $t('AppFieldsManager.Detectar talhões') }}-->
<!--                    </app-button>-->
<!--                </div>-->
                <div class="col">
                    <Button v-if="disableFileUpload" :label="$t('AppFieldsManager.Carregando')"
                            :loading="true" class="shapefile-loading"/>
                    <FileUpload v-else :key="uploadKey" mode="basic" :auto="false"
                                accept=".zip" :maxFileSize="100000000"
                                :chooseLabel="$t('AppFieldsManager.Shapefile')"
                                :customUpload="true" @select="fileSelected"/>
                </div>
                <div v-if="showOperationsCenterButton" class="col-12 mt-3">
                    <app-button type="primary" style="width: 95%;height: 47px;font-size: 18px"
                                :disabled="disableFileUpload" @handleClick='openOperationsCenterImport'>
                        <span class="pi pi-cloud-download pr-2"></span>
                        {{ $t('AppFieldsManager.Importar do Operations Center') }}
                    </app-button>
                </div>
            </div>
        </Dialog>

        <app-operations-center-fields-preview-dialog v-if="showOperationsCenterButton"
                                                     :visible.sync="ocPreviewDialog"
                                                     :org-id="selected_client ? selected_client.id : null"
                                                     @imported="$emit('getFields')"/>

    </div>
</template>

<script>

import FieldsService from "@/services/FieldsService";

import AppButton from "@/components/common/AppButton";
import Divider from 'primevue/divider';
import FileUpload from 'primevue/fileupload';
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button';
import ProgressSpinner from 'primevue/progressspinner';
import Tooltip from 'primevue/tooltip';

import AppShapefilePreviewDialog from "@/components/views/fields/AppShapefilePreviewDialog";
import AppOperationsCenterFieldsPreviewDialog from "@/components/views/fields/AppOperationsCenterFieldsPreviewDialog";

import OrganizationFeatureFlagsMixin from "@/mixins/OrganizationFeatureFlagsMixin";

export default {
    mixins: [OrganizationFeatureFlagsMixin],
    mounted() {
        this.fieldsService = new FieldsService();
        this.is_col_12 = this.isScreenMobile;
    },
    data() {
        return {
            is_col_12: false,
            drawFields: false,
            disableFileUpload: false,
            previewDialog: false,
            previewData: null,
            importing: false,
            uploadKey: 0,
            search: null,
            fieldsListToShow: [],
            selectedField: null,
            addFieldDialog: false,
            ocPreviewDialog: false,
            fieldsService: null
        }
    },
    props: {
        selected_client: {
            type: Object,
        },
        selected_field: {
            type: Object,
        },
        loading: {
            type: Boolean,
        },
        client_with_too_many_fields: {
            type: Boolean,
        },
        fields_list: {
            type: Array,
        },
        detecting_fields: {
            type: Boolean
        }
    },
    methods: {
        createField() {
            this.addFieldDialog = false;
            this.$emit('createNewFieldClicked')
        },
        detectFields() {
            this.addFieldDialog = false;
            this.$emit('detectFields');
        },
        stopFieldDetection() {
            this.addFieldDialog = false;
            this.$emit('stopFieldDetection');
        },
        scrollTo(element, to, duration) {
            let vm = this;
            let start = element.scrollTop,
                change = to - start,
                currentTime = 0,
                increment = 20;

            let animateScroll = function () {
                currentTime += increment;
                let val = vm.easeInOutQuad(currentTime, start, change, duration);
                element.scrollTop = val;
                if (currentTime < duration) {
                    setTimeout(animateScroll, increment);
                }
            };
            animateScroll();
        },
        easeInOutQuad(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        },
        showAreaText(val) {
            return `${this.$t('AppFieldsManager.Área')}: ${val} ha`;
        },
        isSelectedField(fieldId) {
            if (!this.selectedField) {
                return false;
            }

            if (fieldId === this.selectedField.id) {
                return true;
            }
        },
        changeSelectedField(val) {
            this.selectedField = val;
            this.$emit('changeSelectedField', val);
        },
        fileSelected(event) {
            if (!event.files || event.files.length === 0) {
                return;
            }
            let vm = this;
            let formData = new FormData();
            formData.append('multipartFile', event.files[0]);

            vm.disableFileUpload = true;

            this.fieldsService.previewShapefileV3(this.selected_client.id, formData)
                .then(function (response) {
                    if (!response || !response.fields || response.fields.length === 0) {
                        vm.$toast.add({
                            severity: 'warn', summary: vm.$t('AppFieldsManager.Aviso'),
                            detail: vm.$t('AppFieldsManager.Nenhum talhão encontrado no shapefile'), life: 4000
                        });
                        return;
                    }
                    vm.previewData = response;
                    vm.previewDialog = true;
                    vm.addFieldDialog = false;
                }).catch(function (error) {
                let detail = (error && error.response && error.response.data && error.response.data.details)
                    ? error.response.data.details
                    : vm.$t('AppFieldsManager.Não foi possível ler o shapefile');
                vm.$toast.add({
                    severity: 'error', summary: vm.$t('AppFieldsManager.Falha'),
                    detail: detail, life: 5000
                });
            }).finally(() => {
                vm.disableFileUpload = false;
                vm.uploadKey++; // reseta o FileUpload para permitir novo select do mesmo arquivo
            })
        },
        onImport(payload) {
            let vm = this;
            vm.importing = true;

            this.fieldsService.importFieldsV3(this.selected_client.id, payload)
                .then(function (response) {
                    let imported = response && response.imported ? response.imported : 0;
                    let skipped = response && response.skipped ? response.skipped : 0;
                    vm.$toast.add({
                        severity: 'success', summary: vm.$t('AppFieldsManager.Sucesso'),
                        detail: vm.$t('AppFieldsManager.talhões importados', {imported, skipped}), life: 5000
                    });
                    vm.previewDialog = false;
                    vm.$emit('getFields');
                }).catch(function () {
                vm.$toast.add({
                    severity: 'error', summary: vm.$t('AppFieldsManager.Falha'),
                    detail: vm.$t('AppFieldsManager.Não foi possível importar os talhões'), life: 4000
                });
            }).finally(() => {
                vm.importing = false;
            })
        },
        addNewField() {
            this.stopFieldDetection();
            this.addFieldDialog = true;
        },
        openOperationsCenterImport() {
            this.addFieldDialog = false;
            this.ocPreviewDialog = true;
        }
    },
    computed: {
        isScreenMobile: function () {
            return window.screen.width <= 1024;
        },
        showOperationsCenterButton: function () {
            return this.hasFeatureEnabled('OPERATIONS_CENTER_CONNECTION');
        }
    },
    watch: {
        fields_list: function (val) {
            this.fieldsListToShow = val;
        },
        selected_field: function (val) {
            this.selectedField = val;

            if (!val) {
                return;
            }

            let topPos = document.getElementById(this.selectedField.name).offsetTop;
            this.scrollTo(document.getElementById('container'), topPos - 100, 600);
        },
        search: function (val) {
            let tempFieldsToShow = [];

            if (!val) {
                this.fieldsListToShow = this.fields_list;
                return;
            }

            this.fields_list.forEach(field => {
                if (field.name.toLowerCase().includes(val.toLowerCase())) {
                    tempFieldsToShow.push(field);
                }
            })
            this.fieldsListToShow = tempFieldsToShow;
        },
    },
    components: {
        AppButton, Divider, FileUpload, Dialog, InputText, Button, ProgressSpinner, Tooltip,
        AppShapefilePreviewDialog, AppOperationsCenterFieldsPreviewDialog
    },
    directives: {
        tooltip: Tooltip
    },
}
</script>

<style lang="scss">
.p-fileupload {
    margin-top: 0;
    width: 100%;

    .p-button {
        width: 90%;
        height: 47px;
        justify-content: center;
        background-color: #e6b43c;
        border: none;
        font-size: 18px;
    }
}

.shapefile-loading.p-button {
    width: 90%;
    height: 47px;
    justify-content: center;
    background-color: #e6b43c;
    border: none;
    font-size: 18px;
}

.list > .ps > .ps__rail-y > .ps__thumb-y {
    width: 8px !important;
    border-radius: 4px !important;
    opacity: 1 !important;
    background: gray !important;
    min-height: 40px !important;
}

</style>

<style scoped lang="scss">

.add-button {
    padding: 10px;
    margin-top: 25px;
    color: #4b4b4b;
    min-width: 100px;
    border-radius: 3px;
    background-color: #fff;
    text-align: center;
}

.p-inputtext {
    border-radius: 5px;
    width: 100%;
}

.ps {
    max-height: calc(100vh - 300px);
}

.field {
    border-bottom: 1px solid #e0e0e0;
    height: 50px;
    display: flex;
    align-items: center;
    color: #393939;
    padding-left: 10px;
}

.field:hover {
    background-color: #addaff;
    cursor: pointer;
}

.selectedField {
    background-color: #e8e8e8;
    border-right: 1px solid #b0b0b0;
    border-top: 1px solid #b0b0b0;
    border-bottom: 1px solid #b0b0b0;
}

.height-list {
    max-height: 275px;
}

</style>
